import { JsonWebToken, JsonWebTokenHeader, JsonWebTokenPayload } from './types';

const parse = <ReturnType extends JsonWebToken>(
  stringToken: string,
): ReturnType => {
  const [header, payload] = stringToken.split('.');
  return {
    header: JSON.parse(atob(header)) as JsonWebTokenHeader,
    payload: JSON.parse(atob(payload)) as JsonWebTokenPayload,
    rawValue: stringToken,
  } as ReturnType;
};

const getRemainingTimeInSeconds = (token: JsonWebToken): number => {
  const now = Math.floor(Date.now() / 1000);
  const expiresAt = token.payload.exp;
  return Math.max(0, expiresAt - now);
};

const isExpired = (token: JsonWebToken): boolean => {
  return getRemainingTimeInSeconds(token) <= 0;
};

const getTotalDurationInSeconds = (token: JsonWebToken): number => {
  return token.payload.exp - token.payload.iat;
};

const getElapsedTimeInPercent = (token: JsonWebToken): number => {
  const totalDuration = getTotalDurationInSeconds(token);
  const remainingTime = getRemainingTimeInSeconds(token);
  return ((totalDuration - remainingTime) / totalDuration) * 100;
};

const isValid = (token?: JsonWebToken): boolean => {
  if (!token || !token.rawValue) {
    return false;
  }
  return !isExpired(token);
};

const JsonWebTokenService = {
  parse,
  getRemainingTimeInSeconds,
  isExpired,
  getTotalDurationInSeconds,
  getElapsedTimeInPercent,
  isValid,
};

export default JsonWebTokenService;
